var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTriangleRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6464 8.35355L6.85355 12.1464C6.53857 12.4614 6 12.2383 6 11.7929L6 4.20711C6 3.76165 6.53857 3.53857 6.85355 3.85355L10.6464 7.64645C10.8417 7.84171 10.8417 8.15829 10.6464 8.35355Z",
    fill: "#474F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleRightBlack);
export default __webpack_public_path__ + "static/media/icon_triangle_right_black.a2b47d38c0ef32493e376073d49dd7ab.svg";
export { ForwardRef as ReactComponent };